<template>
    <div id="archive">
        <div class="archive-container">
            <div class="archive-contents">
                <div class="students-el"
                v-for="(item, i) in studentLists" :key="i"
                @click="$router.push('/archive/'+item.number)"
                >
                    <p class="emoji">{{ emojiLists[Math.floor(Math.random() * emojiLists.length)] }} </p>
                    <div class="students-name">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            studentLists: this.$store.state.students,
            emojiLists: [ '🎀','💗','💓','💕','💖','💞','💘','💌','🐙','💐','🌸','🌷','🌺','🍄','💝','🎆','🎁','🎉','🎊','🎈','🔮','🎸','👾','🏆','🍺','🍻','🍸','🍹','🍷','🍴','🍕','🍔','🍟','🍗','🍖','🍬','🍭','🍇','🍉','🍓','🍑','🍠','🍆','🍅','🏩','🏨','💒','🌄','🌅','🌉','🎠','🎡','🚺','🆔','💟','⛎','🔯','🔺','⬜','⚪','🔴','🔵','🔻','🔶','🔷','🔸','🔹' ],
        }
    },
    mounted() {
        setInterval(this.$store.commit('showList'), 1000)
    }
}
</script>

<style scoped>
@media all and (max-width: 767px) {
    #archive {
        width: 96vw;
        height: 100vh;
        margin: 0 auto;
        padding: 88px 0;
        display: table;
    }
    .archive-container {
        width: 96vw;
        display: table-cell;
        vertical-align: middle;
    }
    .archive-contents .students-el {
        display: inline-block;
        margin: 24px 1vw;
        cursor: pointer;
    }
    .emoji {
        font-size: 1.5rem;
        padding: 8px;
        text-align: center;
        margin: 0 auto;
    }

    .students-el .students-name {
        width: 100%;
        height: 16px;
        text-align: center;
        font-size: 0.9rem;
        color: #ed86a1;
    }
    /* .emoji {
        display: none;
    } */
}
@media all and (min-width: 768px) {
    #archive {
        width: 82vw;
        height: 100vh;
        margin: 0 auto;
        display: table;
    }
    .archive-container {
        width: 82vw;
        display: table-cell;
        vertical-align: middle;
    }
    .archive-contents .students-el {
        display: inline-block;
        margin: 24px 1vw;
        cursor: pointer;
        opacity: 0;
    }
    .emoji {
        width: 32px;
        height: 32px;
        font-size: 32px;
        margin: 8px auto;
        visibility: hidden;
    }
    .students-el .students-name {
        width: 100%;
        height: 24px;
        padding: 0 0 4px;
        text-align: center;
        font-size: 1.4rem;
        color: #ed86a1;
        border-bottom: 4px solid #000;
    }
    .archive-contents .students-el:hover > .students-name {
        transition: 0.7s;
        box-sizing: content-box;
        border-bottom: 4px solid #ed86a1;
        font-weight: 900;
    }
    .archive-contents .students-el:hover > .emoji {
        visibility: visible;
        transition: 0.7s;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/AppArchive.vue